var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 48,
    viewBox: "0 0 140 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38522 43.6867C6.38522 38.6447 10.4834 34.5573 15.5387 34.5573H38.1547C38.1547 39.5993 34.0565 43.6867 29.0012 43.6867H6.38522Z",
    fill: "url(#paint0_linear_5_1754)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 28.4709C1 23.4288 5.09815 19.3414 10.1535 19.3414H33.1762C33.1762 24.3835 29.0781 28.4709 24.0227 28.4709H1Z",
    fill: "url(#paint1_linear_5_1754)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.876 43.6867C60.7591 44.9916 65.7783 42.1014 67.0868 37.2311L71.8056 19.6662C66.9226 18.3613 61.9033 21.2515 60.5949 26.1218L55.876 43.6867Z",
    fill: "url(#paint2_linear_5_1754)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.481 13.2552C14.481 8.21313 18.5792 4.12573 23.6345 4.12573H46.0203C46.0203 9.1678 41.9222 13.2552 36.8668 13.2552H14.481Z",
    fill: "url(#paint3_linear_5_1754)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.735 13.2552C50.735 8.21313 54.8332 4.12573 59.8885 4.12573H88.8745C88.8745 9.1678 84.7764 13.2552 79.7211 13.2552H50.735Z",
    fill: "url(#paint4_linear_5_1754)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4867 13.2552C93.4867 8.21315 97.5849 4.12575 102.64 4.12575H114.18C114.18 9.16781 110.082 13.2552 105.026 13.2552H93.4867Z",
    fill: "url(#paint5_linear_5_1754)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.406 43.6868C108.406 38.6447 112.504 34.5573 117.559 34.5573H129.099C129.099 39.5994 125.001 43.6868 119.945 43.6868H108.406Z",
    fill: "url(#paint6_linear_5_1754)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.668 4.06425C126.497 3.9124 123.141 3.79021 120.527 6.67416L111.096 17.6649L111.089 17.6579L110.534 18.3201L109.603 19.4047L109.614 19.4164L89.1306 43.8246C90.1072 43.8246 91.0457 43.8507 91.9466 43.8757C96.2608 43.9957 99.712 44.0917 102.348 41.1838L115.475 25.8816L115.48 25.8874L115.973 25.3017L117.009 24.0941L116.998 24.0822L133.761 4.13759C132.684 4.13766 131.653 4.10013 130.668 4.06425Z",
    fill: "url(#paint7_linear_5_1754)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_1754",
    x1: 1,
    y1: 4,
    x2: 133.728,
    y2: 44.1109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#226DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2891FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_1754",
    x1: 1,
    y1: 4,
    x2: 133.728,
    y2: 44.1109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#226DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2891FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_1754",
    x1: 1,
    y1: 4,
    x2: 133.728,
    y2: 44.1109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#226DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2891FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_1754",
    x1: 1,
    y1: 4,
    x2: 133.728,
    y2: 44.1109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#226DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2891FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_1754",
    x1: 1,
    y1: 4,
    x2: 133.728,
    y2: 44.1109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#226DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2891FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_1754",
    x1: 1,
    y1: 4,
    x2: 133.728,
    y2: 44.1109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#226DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2891FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5_1754",
    x1: 1,
    y1: 4,
    x2: 133.728,
    y2: 44.1109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#226DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2891FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5_1754",
    x1: 1,
    y1: 4,
    x2: 133.728,
    y2: 44.1109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#226DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2891FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c2555f7ebea9927a4a2c0f051875ad7b.svg";
export { ForwardRef as ReactComponent };